module.exports = __webpack_public_path__ + "images/emoji/hushed.bcc751d98c97bb8d07ef.png";